import { Component, OnInit, Input } from '@angular/core';
import { Schedule } from 'src/app/shared/models/schedule.model';
import { SchedulesService } from '../schedules.service';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-schedule-item',
    templateUrl: './schedule-item.component.html',
    styleUrls: ['./schedule-item.component.css'],
    standalone: false
})
export class ScheduleItemComponent implements OnInit {

  @Input() elementIndex: number;
  @Input() schedule: Schedule;

  public icons: { [name: string]: any } = {
    'faEdit': faEdit,
    'faTrashAlt': faTrashAlt,
  };

  constructor(private _schedulesService: SchedulesService) {
  }

  ngOnInit(): void {
    if (!this.schedule) {
      this.schedule = this._schedulesService.schedules[this.elementIndex];
    }
  }

  public onEditClick() {
    this._schedulesService.onScheduleEdit.next(this.elementIndex);
  }

  public onDeleteClick() {
    this._schedulesService.onScheduleDelete.next(this.elementIndex);
  }

}
